module.exports = __webpack_public_path__ + "../resources/images/OpenAndEditInCloudFRECallout-e454f5397d3d2f221e4c4ff7aa4d44c4.svg";